import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { signOut } from "firebase/auth";
import { auth } from "@/plugins/firebase.app";
import { orderBy } from "lodash";
import api from "@/api";
import * as Sentry from "@sentry/browser";

Vue.use(Vuex);
const initialState = {
  modernTheme:
    typeof localStorage !== "undefined"
      ? localStorage.getItem("modernTheme") !== "false"
      : true,
  darkMode:
    typeof localStorage !== "undefined"
      ? localStorage.getItem("darkMode") === "true"
      : false,
  drawer: null,
  user: null,
  harjoitukset: [],
  evyharjoitukset: [],
  digivihot: [],
  henkilot: [],
  equipments: [],
  newLoginTimeout: null,
  yksikot: [
    /* HUOM JOS MUOKKAAT NIIN MUOKKAA MYÖS JSREPORTSI */
    {
      id: 1,
      name: "RSA511",
      color: "green lighten-5",
    },
    {
      id: 2,
      name: "RSA5112",
      color: "amber  lighten-5",
    },
    {
      id: 3,
      name: "RSA513",
      color: "blue-grey lighten-5",
    },
    {
      id: 4,
      name: "RSA517",
      color: "lime lighten-5",
    },
    {
      id: 5,
      name: "RSA518",
      color: "blue lighten-5",
    },
    {
      id: 6,
      name: "RSA5182",
      color: "cyan lighten-5",
    },
    {
      id: 7,
      name: "RSA5188",
      color: "brown lighten-5",
    },
    {
      id: 91,
      name: "Tilannepaikanjohtaja",
      color: "purple lighten-5",
    },
    {
      id: 90,
      name: "Asemavalmius",
      color: "grey lighten-4",
    },
    {
      id: 100,
      name: "Asema",
      color: "grey lighten-5",
    },
  ],
};
export default new Vuex.Store({
  state: { ...initialState },
  mutations: {
    setDrawer(state, show) {
      state.drawer = show;
    },
    setUser(state, currentUser) {
      if (!currentUser) {
        state.user = null;
        axios.defaults.headers.common = {
          Authorization: null,
        };
        window.localStorage.removeItem("user");
        Object.assign(state, { ...initialState });
        return;
      }
      if (state.newLoginTimeout) {
        console.log("Clearing new login timeout");
        clearTimeout(state.newLoginTimeout);
      }
      axios.defaults.headers.common = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${currentUser.token?.access_token}`,
      };
      state.user = currentUser;
      try {
        Sentry.setUser({ email: currentUser?.email });
      } catch (e) {
        console.error(e);
      }
    },
    async logout(state) {
      Vue.$toast("Kirjauduttu ulos", {
        type: "info",
      });
      state.user = null;
      axios.defaults.headers.common = {
        Authorization: null,
      };

      await signOut(auth);
    },
    setDigivihot(state, digivihot) {
      state.digivihot = digivihot;
    },
    setHarjoitukset(state, harjoitukset) {
      state.harjoitukset = harjoitukset;
    },
    setEvyHarjoitukset(state, evyharjoitukset) {
      state.evyharjoitukset = evyharjoitukset;
    },
    setHenkilot(state, henkilot) {
      state.henkilot = henkilot;
    },
    setEquipments(state, equipments) {
      state.equipments = equipments;
    },
    setNewLogin(state, newLogin) {
      if (state.newLoginTimeout) {
        clearTimeout(state.newLoginTimeout);
      }
      console.log("Setting new login timeout");
      state.newLoginTimeout = setTimeout(() => {
        console.log("Reloading page after new login");
        window.location.reload();
      }, 1500);
    },
    setModernTheme(state, val) {
      state.modernTheme = val;
      if (typeof localStorage !== "undefined") {
        localStorage.setItem("modernTheme", val);
      }
    },
    setDarkMode(state, val) {
      state.darkMode = val;
      if (typeof localStorage !== "undefined") {
        localStorage.setItem("darkMode", val);
      }
    },
  },
  actions: {
    setDrawer({ commit }, payload) {
      commit("setDrawer", payload);
    },
    toggleModernTheme({ commit, state }) {
      commit("setModernTheme", !state.modernTheme);
    },
    toggleDarkMode({ commit, state }) {
      commit("setDarkMode", !state.darkMode);
    },
    setDarkMode({ commit }, payload) {
      commit("setDarkMode", payload);
    },
    updateUser({ commit }, payload) {
      commit("setUser", payload.currentUser);
    },
    setNewLogin({ commit }, payload) {
      commit("setNewLogin", payload);
    },
    logout({ commit }) {
      commit("logout");
    },
    async loadHarjoitukset({ commit, state }) {
      if (state.harjoitukset.length > 0) return;
      let response = (await api.harjoituksetList()).data;
      const harjoitukset = orderBy(response.harjoitukset, ["date"], ["asc"]);
      commit("setHarjoitukset", harjoitukset);

      const evyharjoitukset = orderBy(response.evy, ["date"], ["asc"]);
      commit("setEvyHarjoitukset", evyharjoitukset);
    },
    async loadDigivihot({ commit, state }, payload) {
      let response = (await api.digivihotListPaged({ year: payload })).data;
      const digivihot = orderBy(response, ["date", "time"], ["desc", "desc"]);
      commit("setDigivihot", digivihot);
    },
    async loadHenkilot({ commit, state }) {
      let response = (await api.henkilotList()).data;
      const henkilot = orderBy(response, ["name"], ["asc"]);
      commit("setHenkilot", henkilot);
    },
    setCachedEquipments({ commit, state }, payload) {
      commit("setEquipments", payload);
    },
  },
  modules: {},
});
